const commonKeys = [
    "fw", "describe", "signal",
];
export function exactOptions(opts, keys) {
    return Object.fromEntries(Object.entries(opts).filter(([key]) => commonKeys.includes(key) || keys.includes(key)));
}
